/**
 * StatCards — summary stat cards for the main dashboard.
 *
 * 3 cards; Grandstream campuses get 2 more (docs/TIME_TO_CONNECT_PLAN.md, phase 3):
 *   Avg Time to Connect — alerts with an answered intercom call only (sp_getSummaryStat v3), N/A when none
 *   Intercom Usage      — alerts with a placed intercom call / all alerts in the same 28-day event set
 */

import HeaderInfoTip from '../../../../components/v2/HeaderInfoTip.jsx';
import { TIME_TO_CONNECT_INFO, INTERCOM_USAGE_INFO, TIME_TO_CONNECT_NA }
    from '../../../reports/alert-details/timeToConnect.js';

const StatCards = ({ statData, loading, isGrandstream = false }) => {
    const count = isGrandstream ? 5 : 3;
    const rowClass = `md-stat-row${isGrandstream ? ' md-stat-row--5' : ''}`;

    if (loading) {
        return (
            <div className={rowClass}>
                {Array.from({ length: count }, (_, i) => (
                    <div key={i} className="md-stat-card">
                        <div className="md-stat-card__value" style={{ color: 'var(--color-text-muted)' }}>—</div>
                        <div className="md-stat-card__label">Loading...</div>
                    </div>
                ))}
            </div>
        );
    }

    /* The proc returns NULL for both when the campus isn't Grandstream, and for the
       average when no alert in the window used the intercom: N/A, never 0. */
    const connect = statData?.avg_time_to_connect;
    const usage = statData?.intercom_usage_pct;

    return (
        <div className={rowClass}>
            <div className="md-stat-card">
                <div className="md-stat-card__value">{statData?.avg_daily_events ?? 0}</div>
                <div className="md-stat-card__label">Avg Daily Alarms</div>
            </div>
            <div className="md-stat-card">
                <div className="md-stat-card__value">{statData?.avg_response_time ?? '0.0'} min</div>
                <div className="md-stat-card__label">Avg Response Rate</div>
            </div>
            <div className="md-stat-card">
                <div className="md-stat-card__value">{statData?.percent_events_over_20 ?? '0.0'}%</div>
                <div className="md-stat-card__label">Alarms Over 20 Min</div>
            </div>
            {isGrandstream ? (
                <>
                    <div className="md-stat-card">
                        <div className="md-stat-card__value">{connect != null ? `${connect} min` : TIME_TO_CONNECT_NA}</div>
                        <div className="md-stat-card__label">
                            Avg Time to Connect
                            <HeaderInfoTip title="Time to Connect" body={TIME_TO_CONNECT_INFO} />
                        </div>
                    </div>
                    <div className="md-stat-card">
                        <div className="md-stat-card__value">{usage != null ? `${usage}%` : '-'}</div>
                        <div className="md-stat-card__label">
                            Intercom Usage
                            <HeaderInfoTip title="Intercom Usage" body={INTERCOM_USAGE_INFO} />
                        </div>
                    </div>
                </>
            ) : null}
        </div>
    );
};

export default StatCards;
